import React from 'react';
import Utils from '../../../common/Utils';
import Classes from '../../../common/Classes';
import classnames from 'classnames';
import RightArrowIcon from '../../../recommendation/RightArrowIcon';
import Tags from '../../../common/dtmTags';
import {DataDtmActions} from '../../../common/Constants';

const InlineRecommendationButton = ({exhibitorId, exhibitorName, translations, interfaceLocale}) => {
    const recommendationUrl = Utils.getRecommendationURL(interfaceLocale, exhibitorId);

    return (
        <a
            href={recommendationUrl}
            data-testId='inline-recommendation-test-id'
            className={classnames(Classes.inlineRecommendationButton)}
            data-dtm={Tags.exhibitorDirectory.inlineRecommendation}
            data-dtm-actions={DataDtmActions.click}
            data-dtm-attributes={JSON.stringify({exhibitorId: exhibitorId})}
            style={{backgroundColor: `${window.reactSettings.props.themes.brandPrimary}73`}}>
            <div className={classnames(Classes.inlineRecommendationButtonContent)} >
                <h3
                    className={classnames(Classes.exhibitorName, Classes.wrapWord, Classes.singleLineEllipsis, Classes.inlineRecommendationButtonExhbitorName)}>
                    <span className={classnames(Classes.discoverMoreLike)}>
                        {translations.exhibitorDirectoryRecommendation.discoverMoreLikeButtonText}
                    </span>
                    &nbsp;
                    <span className={classnames(Classes.recommendedExhibitorName)}>
                        {exhibitorName?.toUpperCase()}
                    </span>
                </h3>
            </div>
            <RightArrowIcon width={'12px'} height={'17px'} color={'#2d2d2d'} />
        </a>
    );
};

export default InlineRecommendationButton;
